import { useContext } from "react";
import { SettingsContext } from "../App";
import CloseButton from "./CloseButton";
import Allergens from "./Allergens";
import Label from "./Label";

// Nome con tasto info in linea, poi descrizione (se abilitata), poi icone allergeni su una riga propria.
// Il tasto info è uno span e non un button: Variants.js conta i button per leggere le scelte.
export function SubproductDetails({ product, onInfo, children }) {
	const { settings, lang } = useContext(SettingsContext);
	const showDescription = settings?.menu_api?.show_subproducts_description == 1;
	const allergens = product.allergens || [];

	return (
		<div className="subproduct-body">
			<div className="subproduct-head">
				{children}
				<span
					role="button"
					tabIndex={0}
					className="subproduct-info-button"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onInfo(product);
					}}
				>
					i
				</span>
			</div>
			{showDescription && product.description && (
				<div
					className="subproduct-description"
					dangerouslySetInnerHTML={{ __html: product.description }}
				/>
			)}
			{allergens.length > 0 && (
				<div className="subproduct-allergens">
					<Allergens
						allergens={allergens}
						color="#000"
						backgroundColor="#ddd"
						lang={lang}
						iconsOnly
					/>
				</div>
			)}
		</div>
	);
}

export default function SubproductInfo({ product, onClose }) {
	const { settings, lang } = useContext(SettingsContext);
	const allergens = product.allergens || [];

	return (
		<div id="subproduct-info" className="popup" onClick={onClose}>
			<div className="content" onClick={(e) => e.stopPropagation()}>
				<div className="popup-header">
					<CloseButton onClick={onClose} />
					<h3 className="mb-0">{product.name}</h3>
				</div>
				<div className="popup-scroll">
					<div className="popup-content">
						{product.img && (
							<div className="img">
								<img src={product.img} />
							</div>
						)}
						{product.description && (
							<div
								className="description"
								dangerouslySetInnerHTML={{ __html: product.description }}
							/>
						)}
						{allergens.length > 0 && (
							<>
								<div
									className="subtitle"
									style={{
										backgroundColor: settings.selfordering.color1,
										color: settings.selfordering.color2,
									}}
								>
									<Label number={41} />
								</div>
								<div className="allergens">
									<Allergens
										allergens={allergens}
										color="#000"
										backgroundColor="#ccc"
										lang={lang}
									/>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
